'use client';

import { useActivitiesByCategory } from '@website/hooks/useActivitiesByCategory';

import { CategoryActivitiesSection } from './CategoryActivitiesSection';

interface CategoryActivitiesClientProps {
  category: string | undefined | null;
  excludeActivityId: string;
}

/**
 * Client-side "similar activities in this category" rail.
 *
 * Fetched in the browser (TanStack Query) rather than at build/SSR, so:
 *  - it never runs the heavy category query during the deploy build (that
 *    query's per-row availability EXISTS + booking-count subqueries are what
 *    stampeded the build), and
 *  - it is never baked into the cached page HTML, so it can't surface stale
 *    links to activities that were since archived/edited — it's always current.
 * The query is capped (see useActivitiesByCategory) so it stays fast.
 */
export default function CategoryActivitiesClient({ category, excludeActivityId }: CategoryActivitiesClientProps) {
  const { data, isLoading, isError } = useActivitiesByCategory(category ?? '', excludeActivityId);

  if (!category) return null;

  return (
    <CategoryActivitiesSection activities={data ?? []} category={category} isLoading={isLoading} isError={isError} />
  );
}
